<template>
  <v-app style="background:#fff;">
    <Header @showLogin="login_dialog({show: true})" />
    <dashboard-core-drawer />
    <v-content>
      <transition>
      <router-view />
      </transition>
    </v-content>
        <v-dialog
      v-model="login_visible"
      persistent
      width="500"
    >
      <v-card>
        <v-tabs
          v-model="tab"
          background-color="secondary"
          active-class="active-tab"
          dark
          fixed-tabs
        >
          <v-tab href="#tab-1">
            Log In
          </v-tab>
          <v-tab href="#tab-2">
            Register
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1" >
            <Login @closeLogin="closeLogin" />
          </v-tab-item>
          <v-tab-item value="tab-2" >
            <Register @closeLogin="closeLogin" />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
    <Footer />
    <!-- COOKIES SNACK BAR -->
    <v-snackbar
      :timeout=cookieTimeout
      v-model="cookies"
    >
      This site uses cookies to function. For more information follow 
      the link provided.
      <br /> 
      <a href="https://support.google.com/analytics/answer/6004245" target="_blank">Safeguarding your data</a>
      <v-btn
        text
        @click="acceptCookies"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

  export default {
    name: 'App',
    data() {
      return {
        tab: null,
        loginDialog: false,
        cookies: false,
        cookieTimeout: 0
      }
    },
    computed: {
      ...mapState('Ui', ['login_visible'])
    },
    methods: {
      ...mapMutations('Ui', ['login_dialog']),
      ...mapMutations('Diary', ['unsubscribeDiaryUpdates']),
      ...mapMutations('Profile', ['unsubscribeProfileUpdates']),
      closeLogin() {
        this.login_dialog({ show: false });      
      },
      acceptCookies() {
        if (!localStorage.hideCookies) {
          localStorage.hideCookies = false;
          this.cookies = false;
        }
      },
      unsubscribeFirebaseUpdates() {
        this.unsubscribeDiaryUpdates();
        this.unsubscribeProfileUpdates();
        return true;
      },
      scrollFix: function(hashbang)
      {
        location.hash = hashbang;
      }
    },
    mounted() {
      this.cookies = !localStorage.hideCookies;
      setTimeout(() => this.scrollFix(this.$route.hash), 500);
    },
    components: {
      Header: () => import('./components/Header'),
      Footer: () => import('./components/Footer'),
      Login: () => import('./components/Login'),
      Register: () => import('./components/Register'),      
      DashboardCoreDrawer: () => import('./views/dashboard/components/core/Drawer'),
    },
    created() {
      window.addEventListener('beforeunload', this.unsubscribeFirebaseUpdates)
    },
  }
</script>
<style>
  body, html {
      position:relative;
  }

  h1, h2 {
      font-family: 'Montserrat', sans-serif;
      font-size:36px;
  }

  h2 {
      font-size: 28px;
  }

  @media (min-width: 1264px) {
      .container {
          max-width: 960px !important;
      }
  }
    
  .active-tab {
    background-color: #f7be21
  }

  /* HACK: removes left margin from tabs  */
  .v-application--is-ltr .v-tabs-bar.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tabs-slider-wrapper + .v-tab {
    margin-left: 0 !important;
  }
</style>